/* Watches for simgate.updatePath to be called and creates a snapshot when it is */

var snapshotOnAdvance = function (global) {

	var waitForSimgate = setInterval(function () {
		if (window.simgate) {
			clearInterval(waitForSimgate);

			var _updatePath = window.simgate.updatePath;
			window.simgate.updatePath = function (args) {

				var promise = _updatePath.apply(this || window.simgate, arguments);
				var path = args && args.path;
				var nextState = args && args.set && args.set.attr4;
				var nextRound = args && args.set && args.set.num5;

				if (path && nextState && nextRound) {
					promise.always(function (result) {
            var url = window.getOverloadedParam("snapshotServicePath", { defaultValue: "https://api.regis-co.com/v1/snapshot/", ensureEndingSlash: true, asUrl: true, path: path.toString() });
						fetch(url.href, {
							"body": JSON.stringify({
								"fromSim": true,
								"round": nextRound,
								"state": nextState,
								"path": path
							}),
							"headers": {
								"accept": "*/*",
								"authorization": window.simgate.context.token,
								"cache-control": "no-cache",
								"content-type": "application/json",
							},
							"method": "POST",
							"mode": "cors"
						}).then(function (response) {
							return response.json();
						}).catch(function (error) {
							console.error("Failed to create snapshot");
							console.error(error);
						});

						return result;
					});
				}
				
				return promise;
			}
		}
	}, 10);
}

snapshotOnAdvance(typeof window !== undefined ? window : typeof global !== undefined ? global : {});
